class HoshokuWardrobe extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    const signal = this.#abort.signal;
    this.querySelectorAll('[data-wardrobe-choice]').forEach((button) => {
      button.addEventListener('click', this.#select, { signal });
    });
    this.#loadModelViewer();
  }

  disconnectedCallback() { this.#abort.abort(); }

  #select = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;
    const slot = button.dataset.slot;
    if (!slot) return;

    this.querySelectorAll(`[data-wardrobe-choice][data-slot="${CSS.escape(slot)}"]`).forEach((choice) => {
      choice.setAttribute('aria-pressed', String(choice === button));
    });

    const target = this.querySelector(`[data-loadout="${CSS.escape(slot)}"]`);
    if (target) target.textContent = button.dataset.title || 'NONE';

    const preview = this.querySelector('[data-wardrobe-preview]');
    if (preview instanceof HTMLImageElement && button.dataset.preview) {
      preview.src = button.dataset.preview;
      preview.alt = `${button.dataset.title || 'Selected garment'} HOSHOKU preview`;
    }

    const productLink = this.querySelector('[data-selected-product]');
    if (productLink instanceof HTMLAnchorElement && button.dataset.url) {
      productLink.href = button.dataset.url;
      productLink.textContent = `VIEW ${button.dataset.shortTitle || button.dataset.title || 'GARMENT'}`;
      productLink.hidden = false;
    }

    const viewer = this.querySelector('model-viewer');
    if (viewer && button.dataset.model && viewer.getAttribute('src') !== button.dataset.model) {
      this.setAttribute('data-model-loading', '');
      viewer.addEventListener('load', () => this.removeAttribute('data-model-loading'), {
        once: true,
        signal: this.#abort.signal,
      });
      viewer.addEventListener('error', () => this.removeAttribute('data-model-loading'), {
        once: true,
        signal: this.#abort.signal,
      });
      viewer.setAttribute('src', button.dataset.model);
    }

    this.dispatchEvent(new CustomEvent('wardrobe:change', {
      bubbles: true,
      detail: { slot, title: button.dataset.title, productHandle: button.dataset.handle },
    }));
  };

  #loadModelViewer() {
    const viewer = this.querySelector('model-viewer');
    if (!viewer || customElements.get('model-viewer')) return;
    const existing = document.querySelector('script[data-hoshoku-model-viewer]');
    if (existing) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.12/model-viewer.js';
    script.dataset.hoshokuModelViewer = '';
    document.head.append(script);
  }
}

if (!customElements.get('hoshoku-wardrobe')) customElements.define('hoshoku-wardrobe', HoshokuWardrobe);
